export default __webpack_public_path__ + "static/media/progressbar-watch-icon.1159cc66.svg";